import cx from 'classnames'
import type { ComponentProps, ReactNode } from 'react'
import { ErrorBoundary } from 'react-error-boundary'

import type { ErrorFallback } from '../../feedback/errorFallback/ErrorFallback'
import { paperStyles } from '../../libs/paperStyles'
import { ErrorFallbackCard } from './ErrorFallbackCard'

type Props = ComponentProps<'div'> & {
  /**
   * Optional custom error fallback component to render when an error occurs inside the card.
   */
  ErrorFallback?: typeof ErrorFallback
  /**
   * Title to display when an error occurs inside the card, would often be the same as the regular card title, but in case the card title is dynamic or a react component, we need a simple string representation to show when in error state.
   */
  fallbackTitle?: string | ReactNode
}

export const Card = ({
  className,
  ErrorFallback: CustomErrorFallback,
  fallbackTitle,
  ...restProps
}: Props) => (
  <ErrorBoundary
    FallbackComponent={(props) => (
      <ErrorFallbackCard
        {...props}
        fallbackTitle={fallbackTitle}
        CustomErrorFallback={CustomErrorFallback}
      />
    )}
  >
    <div
      className={cx(
        'rounded-xl p-1 flex flex-col gap-1',
        paperStyles({ isFaded: true, ringColor: 'grey' }),
        className,
      )}
      data-amaze-card
      {...restProps}
    />
  </ErrorBoundary>
)
